import React from "react";
import { Modal, Typography, Flex, Button, Avatar } from "antd";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import logoImg from "../../assets/logo/dealVoice.png";

const { Title, Text, Paragraph } = Typography;

function LogoutConfirmModal({ open, onCancel, onConfirm, userName = "Administrator", companyName = "Softrate Global", loading = false }) {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      width={420}
      styles={{
        body: {
          padding: "24px 20px 20px",
          textAlign: "center",
        },
      }}
    >
      <Flex vertical align="center" gap={16}>
        {/* Header with Logo and Icon */}
        <Flex justify="space-between" align="center" style={{ width: "100%" }}>
          {/* DealVoice Brand Logo */}
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
            }}
          >
            <img src={logoImg} alt="DealVoice" style={{ height: 32, objectFit: "contain" }} />
          </div>

          {/* Warning Icon Badge */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              color: "#e11d48",
              fontSize: 22,
            }}
          >
            <LogoutOutlined />
          </div>
        </Flex>

        {/* Modal Headings */}
        <Flex vertical align="center" gap={6} style={{ maxWidth: 340 }}>
          <Title level={4} style={{ margin: 0, color: "#0f172a", fontWeight: 700 }}>
            Confirm Sign Out
          </Title>
          <Paragraph type="secondary" style={{ margin: 0, fontSize: "0.875rem", color: "#64748b", lineHeight: 1.5 }}>
            Are you sure you want to log out of your DealVoice workspace?
          </Paragraph>
        </Flex>

        {/* User Profile Capsule */}
        {(userName || companyName) && (
          <div
            style={{
              width: "100%",
              background: "#f8fafc",
              border: "1px solid #f1f5f9",
              borderRadius: 10,
              padding: "10px 14px",
              display: "flex",
              alignItems: "center",
              gap: 10,
              textAlign: "left",
            }}
          >
            <Avatar style={{ backgroundColor: "#2459d3" }} icon={<UserOutlined />}>
              {(userName || "A").charAt(0).toUpperCase()}
            </Avatar>
            <Flex vertical style={{ flex: 1, minWidth: 0 }}>
              <Text strong style={{ fontSize: "0.85rem", color: "#1e293b" }} ellipsis>
                {userName}
              </Text>
              <Text type="secondary" style={{ fontSize: "0.75rem", color: "#64748b" }} ellipsis>
                {companyName}
              </Text>
            </Flex>
          </div>
        )}

        {/* Action Buttons */}
        <Flex justify="center" gap={12} style={{ width: "100%", marginTop: 8 }}>
          <Button
            onClick={onCancel}
            style={{
              flex: 1,
              height: 40,
              borderRadius: 8,
              fontWeight: 600,
            }}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            danger
            icon={<LogoutOutlined />}
            loading={loading}
            onClick={onConfirm}
            style={{
              flex: 1,
              height: 40,
              borderRadius: 8,
              fontWeight: 600,
              background: "#e11d48",
              borderColor: "#e11d48",
            }}
          >
            Log Out
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
}

export default LogoutConfirmModal;
